import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../../hooks/useLatestRequest";
import { authApi } from "../../api";
import type {
  CategoryResponse,
} from "../types/merchantRegister.types";

interface UseMerchantRegistrationOptionsReturn {
  categoryOptions: CategoryResponse[];
  error: Error | null;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

export const useMerchantRegistrationOptions = (): UseMerchantRegistrationOptionsReturn => {
  const [categoryOptions, setCategoryOptions] = useState<CategoryResponse[]>([]);
  const [error, setError] = useState<Error | null>(null);
  const { loading: isLoading, run: runCategoryRequest } = useLatestRequest();

  const refetch = useCallback(async () => {
    setError(null);

    try {
      const categories = await runCategoryRequest((signal) => authApi.getMerchantCategories(signal));

      if (categories) {
        setCategoryOptions(categories);
      }
    } catch (requestError: unknown) {
      setError(
        requestError instanceof Error
          ? requestError
          : new Error("Failed to load merchant registration options"),
      );
    }
  }, [runCategoryRequest]);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return {
    categoryOptions,
    error,
    isLoading,
    refetch,
  };
};
